import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { Heading, Text } from '../styles/components';



const ProcessingWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: ${props => props.theme.spacing.xl};
  text-align: center;
  min-height: 350px;
`;

const StepList = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
    margin: 2rem 0;
    width: 100%;
    max-width: 280px;
`;

const StepItem = styled.div`
    display: flex;
    align-items: center;
    gap: 10px;
    font-size: 0.95rem;
    color: ${props => props.$active ? props.theme.colors.charcoal : props.$completed ? props.theme.colors.sage : '#ccc'};
    font-weight: ${props => props.$active ? '600' : '400'};
    transition: all 0.3s ease;
    
    svg {
        width: 18px;
        height: 18px;
        color: ${props => props.$completed ? props.theme.colors.sage : props.$active ? props.theme.colors.terracotta : '#eee'};
    }
`;

const LoadingSpinner = styled.div`
    width: 18px;
    height: 18px;
    border: 2px solid ${props => props.theme.colors.terracotta};
    border-top-color: transparent;
    border-radius: 50%;
    animation: spin 0.8s linear infinite;
    
    @keyframes spin {
        to { transform: rotate(360deg); }
    }
`;

const CheckIcon = () => (
  <svg fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M5 13l4 4L19 7" /></svg>
);

const PendingIcon = () => (
  <svg fill="none" viewBox="0 0 24 24" stroke="currentColor"><circle cx="12" cy="12" r="9" strokeWidth={2} strokeDasharray="4 4" /></svg>
);


const MESSAGES = [
  "Reading PDF...",
  "Analyzing Strategy...",
  "Identifing Gaps...",
  "Drafting Report..."
];

const AssessmentProcessing = () => {
  const [currentStep, setCurrentStep] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentStep(prev => (prev < MESSAGES.length - 1 ? prev + 1 : prev));
    }, 15000); // Change step every 15 seconds (total ~60s)

    return () => clearInterval(interval);
  }, []);

  return (
    <ProcessingWrapper>
      <Heading as="h3" size="h4" $mb="1rem">Analyzing your deck...</Heading>

      <StepList>
        {MESSAGES.map((msg, idx) => (
          <StepItem key={idx} $active={idx === currentStep} $completed={idx < currentStep}>
            {idx < currentStep ? <CheckIcon /> : (idx === currentStep ? <LoadingSpinner /> : <PendingIcon />)}
            {msg}
          </StepItem>
        ))}
      </StepList>

      <Text size="small" color="textLight">This usually takes about 60 seconds.</Text>
    </ProcessingWrapper>
  );
};

export default AssessmentProcessing;
